/* eslint-disable */

import 'leaflet/dist/leaflet.css';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import L from 'leaflet';
import 'leaflet.markercluster';

// --- Placeholder pin colours — change these to match the site palette ---
const PIN_DEFAULT   = '#3f3e31'; // standard location pin
const PIN_EXECUTION = '#364644'; // execution site pin
const PIN_FATALITY  = '#485048'; // fatality site 
// -------------------------------------------------------------------------

// On touch devices, require two fingers to pan the map so single-finger scroll works.
// Leaflet sets touch-action:none (inline) on its container and child elements.
// We override this with a CSS !important rule tied to .map-scroll-enabled so the
// browser handles single-finger scroll at compositor level — no JS can block it.
function enableMobileTwoFingerDrag(leafletMap) {
    const container = leafletMap.getContainer();
    // Always set touch-action:pan-y via the CSS class so the browser compositor
    // allows native single-finger page scroll. touch-action has no effect on
    // mouse events, so desktop mouse dragging is completely unaffected here.
    container.classList.add('map-scroll-enabled');
    // Do NOT disable dragging at init. Only disable it reactively inside the
    // touchstart handler below. On a desktop (no touchscreen) touchstart never
    // fires, so dragging is never disabled and mouse drag always works.
    const hint = document.createElement('div');
    hint.className = 'map-gesture-hint';
    hint.textContent = 'Use two fingers to move the map';
    container.appendChild(hint);
    let hintTimer;
    container.addEventListener('touchstart', function(e) {
        if (e.touches.length >= 2) {
            container.classList.remove('map-scroll-enabled');
            leafletMap.dragging.enable();
            hint.classList.remove('visible');
            clearTimeout(hintTimer);
        } else {
            container.classList.add('map-scroll-enabled');
            leafletMap.dragging.disable();
            hint.classList.add('visible');
            clearTimeout(hintTimer);
            hintTimer = setTimeout(function() { hint.classList.remove('visible'); }, 1500);
        }
    }, { passive: true });
    container.addEventListener('touchend', function(e) {
        if (e.touches.length < 2) {
            leafletMap.dragging.disable();
            container.classList.add('map-scroll-enabled');
        }
    }, { passive: true });
}

// Returns a teardrop SVG divIcon in the given colour
function createPinIcon(color) {
    return L.divIcon({
        className: '',
        html: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 36" width="24" height="36">
            <path d="M12 0C5.4 0 0 5.4 0 12c0 7.2 12 24 12 24S24 19.2 24 12C24 5.4 18.6 0 12 0z"
                  fill="${color}" stroke="white" stroke-width="1.5"/>
            <circle cx="12" cy="12" r="4" fill="white"/>
        </svg>`,
        iconSize:     [24, 36],
        iconAnchor:   [12, 36],
        popupAnchor:  [0, -38],
    });
}

// All rows for this reference code, injected by the Twig template
const rows = window.location1916Rows;
const firstRow = rows[0];

const pinColor = firstRow.execution == 1 ? PIN_EXECUTION
               : firstRow.fatality  == 1 ? PIN_FATALITY
               : PIN_DEFAULT;
const icon = createPinIcon(pinColor);

// Collect all valid lat/lng pairs across every matching row.
// Each row can have a primary pair plus up to 9 extras (latitude_2…latitude_10).
const validPairs = [];
rows.forEach(row => {
    const pairs = [{ lat: row.latitude, lng: row.longitude, locationText: row.location }];
    for (let i = 2; i <= 10; i++) {
        pairs.push({ lat: row[`latitude_${i}`], lng: row[`longitude_${i}`], locationText: row[`location_${i}`] });
    }
    pairs.forEach(({ lat, lng, locationText }) => {
        const latF = parseFloat(lat);
        const lngF = parseFloat(lng);
        if (!isNaN(latF) && !isNaN(lngF) && (latF !== 0 || lngF !== 0)) {
            validPairs.push([latF, lngF, locationText || '']);
        }
    });
});

if (!validPairs.length) {
    // No usable coordinates — hide the map wrapper entirely
    const wrapper = document.getElementById('map-1916-single-wrapper');
    if (wrapper) wrapper.style.display = 'none';
} else {
    const map = L.map('map-1916-single').setView(validPairs[0], 13);
    enableMobileTwoFingerDrag(map);

    // Mapbox tile layer — swap the style ID for any style from your Mapbox Studio account
    // Restrict this token to your domain: Mapbox dashboard → Tokens → edit → Allowed URLs
    const MAPBOX_TOKEN = 'pk.eyJ1Ijoic2VhbmNvbjczIiwiYSI6ImNtbWF1eGV2OTBnbWgycnNkOGxmaDEwbzcifQ.BdNcGJ_7H_aj9YTmmYIWfg';
    // const MAPBOX_STYLE = 'mapbox/streets-v12'; // change to your custom style ID if needed
    const MAPBOX_STYLE = 'seancon73/cmmdnwa32009s01sk6jku8zqz';

    L.tileLayer(`https://api.mapbox.com/styles/v1/${MAPBOX_STYLE}/tiles/256/{z}/{x}/{y}?access_token=${MAPBOX_TOKEN}`, {
        attribution: '&copy; <a href="https://www.mapbox.com/">Mapbox</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        tileSize: 256,
        maxZoom: 19,
    }).addTo(map);

    // Cluster group handles spiderification when multiple pins share exact coordinates
    const clusterGroup = L.markerClusterGroup({
        spiderfyOnMaxZoom: true,
        polygonOptions: {
            color:       '#626d46',
            fillColor:   '#8aad7f',
            weight:      2,
            opacity:     0.8,
            fillOpacity: 0.2,
        },
    });
    map.addLayer(clusterGroup);

    const basePopup = `<strong>${firstRow.name || ''}</strong>`;

    const newMarkers = validPairs.map(([lat, lng, locationText]) => {
        const popup = basePopup + (locationText ? `<br>Location: ${locationText}` : '');
        return L.marker([lat, lng], { icon }).bindPopup(popup);
    });

    clusterGroup.addLayers(newMarkers);

    // Recalculate size once layout is fully resolved, then fit bounds so all
    // markers are visible with correct container dimensions.
    window.addEventListener('load', () => {
        map.invalidateSize();
        if (validPairs.length > 1) {
            map.fitBounds(validPairs.map(([lat, lng]) => [lat, lng]), { padding: [30, 30] });
        }
    });
}

/* eslint-enable */
